// EmdgLinkList.tsx
import React from 'react';
import EmdgLinkListItem, { EmdgLink } from './EmdgLinkListItem';

interface EmdgLinkListProps {
  inline?: boolean;
  items: EmdgLink[];
}

const EmdgLinkList: React.FC<EmdgLinkListProps> = ({ inline, items }) => (
  <ul className={`emdg-link-list${inline ? ' emdg-link-list--inline' : ''}`}>
    {items.map((item, i) => (
      <EmdgLinkListItem key={i} {...item} />
    ))}
  </ul>
);

export default EmdgLinkList;
